// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"138":"profile","609":"faq","619":"pay"}[chunkId] + "." + {"138":"7c69113f","609":"2016251d","619":"6a1b6865"}[chunkId] + ".js";
};